import React from "react";

export default function Versao1017() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-green-700">
        Melhorias Recentes – Versão 1.0.17
      </h2>

      <ul className="space-y-4 text-green-700 text-base leading-relaxed">
        <li>
          <strong>📊 Nova Tela de Relatórios:</strong>
          <p className="ml-4">
            Agora o sistema permite que o usuário gere relatórios filtrando por
            <strong> período</strong>, <strong> cliente</strong> e
            <strong> técnico responsável</strong>. Os resultados são exibidos em
            uma tabela moderna com paginação e indicadores de status coloridos.
            ✅
          </p>
        </li>
      </ul>
    </div>
  );
}
